export default "__VITE_ASSET__7tf8S40b__"